import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import BulkActionJobErrorViewModel from './BulkActionJobErrorViewModel'
import { observer } from 'mobx-react'
import * as React from 'react'
import Button from 'components/Button'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableHost,
  TableRow,
} from 'components/Table'
import styles from './BulkActionJobErrorDialog.sass'

interface CopyJobDialogProps {
  vm: BulkActionJobErrorViewModel
}

export default observer(function BulkActionJobsErrorDialog({
  vm,
}: CopyJobDialogProps) {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close} large>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={require('assets/images/img_archive-item.svg')}
            alt="Jobs can't be cloned"
          />
          <ModalSheetContentTitle>
            These jobs can't be processed
          </ModalSheetContentTitle>
        </ModalSheetContentBlock>
        <ModalSheetContentBlock>
          <TableHost>
            <Table striped>
              <TableHead>
                <TableHeader align="left">Job title</TableHeader>
                <TableHeader align="left">Job ID</TableHeader>
                <TableHeader align="left">Error</TableHeader>
              </TableHead>
              <TableBody>
                {vm.errors.map((error) => (
                  <TableRow key={error.jobId}>
                    <TableCell
                      align="left"
                      className={styles.copyJobErrorJobId}
                    >
                      {error.jobTitle}
                    </TableCell>
                    <TableCell align="left">{error.jobId}</TableCell>
                    <TableCell
                      align="left"
                      className={styles.copyJobErrorMessage}
                    >
                      {error.error}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableHost>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.close}>Close</Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
